import { render, staticRenderFns } from "./deliveries.vue?vue&type=template&id=e8d3b546&scoped=true"
import script from "./deliveries.vue?vue&type=script&lang=js"
export * from "./deliveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d3b546",
  null
  
)

export default component.exports